<template>
 <div class="container d-flex align-items-center flex-column mt-1">
    <div class="maincontent-bg d-flex flex-column">
      <rule-header :value="ruleHeader"/>
      <rule-game :title="ruleTitle.payRate" :value="rulePayrate"/>
      <rule-game :title="ruleTitle.rule" :value="ruleGame"/>
      <rule-game :title="ruleTitle.score" :value="ruleScore"/>
    </div>
  </div>
</template>

<script>
import Board from '../../assets/gamerule/pokdeng/PD-Board.png';
import Pd1 from '../../assets/gamerule/pokdeng/01.png';
import Pd2 from '../../assets/gamerule/pokdeng/02.png';
import Pd3 from '../../assets/gamerule/pokdeng/03.png';
import Pd4 from '../../assets/gamerule/pokdeng/04.png';
import Pd5 from '../../assets/gamerule/pokdeng/05.png';
import Pd6 from '../../assets/gamerule/pokdeng/06.png';
import Pd7 from '../../assets/gamerule/pokdeng/07.png';
import Pd8 from '../../assets/gamerule/pokdeng/08.png';
import Pd9 from '../../assets/gamerule/pokdeng/09.png';
import Pd10 from '../../assets/gamerule/pokdeng/10.png';

export default {
  name: 'rule_pokdeng',
  data() {
    return {

      ruleHeader: {
        gameName: 'ป๊อกเด้ง (Pokdeng)',
        boardImg: Board,
      },
      ruleTitle: {
        payRate: 'อัตราการจ่าย',
        rule: 'กติกา',
        score: 'แต้มไพ่',
      },
      rulePayrate: [
        {
          type: 'text',
          text: 'อัตราจ่าย 1 : 0.97',
        },
        {
          type: 'text',
          text: 'หากผู้เล่นลงเดิมพัน 100 บาท และได้รับชัยชนะ ผู้เล่นจะได้รับเงินจากการเดิมพัน 97 บาท',
        },
      ],
      ruleGame: [
        {
          type: 'text',
          text: 'ในส่วนของผลตอบแทนเรียงตามอัตราการจ่ายของเจ้า',
        },
        {
          type: 'textSub',
          text: 'ตอง อัตราจ่าย 5 เท่า , เรียงฟรัช อัตราจ่าย 5 เท่า , เรียง อัตราจ่าย 3 เท่า , เซียน อัตราจ่าย 3 เท่า , 3 เด้ง อัตราจ่าย 3 เท่า , 2 เด้ง อัตราจ่าย 2 เท่า , ป๊อก 8 - 9 อัตราจ่าย 1 เท่า , ชนะเจ้ากินตามอัตราของแต่ละคน',
          class: 'ml-3',
        },
        {
          type: 'text',
          text: 'ลำดับการเอาชนะของไพ่และผลตอบแทน',
          class: 'mt-2',
        },
        {
          type: 'textSub',
          text: 'สำหรับลำดับการชนะจะเรียงดังต่อไปนี้ ป๊อก 9 (ป๊อกเก้า 2 เด้ง) > ป๊อก 8 (ป๊อกแปด 2 เด้ง) > ตอง > เรียงฟรัช > เรียง > เซียน > 3 เด้ง > 2 เด้ง > แต้มปกติ',
          class: 'ml-3',
        },
        {
          type: 'textSubcolor',
          textSub: 'ถ้าหากผู้เล่นได้ 6 หรือ 7 แต้ม จะไม่สามารถจั่วไพ่ใบต่อไปได้ จะจั่วไพ่ได้ก็ต่อเมื่อมีลุ้น',
          classMain: 'ml-3',
          textSubcolor: 'ตอง เรียง',
          textSub1: 'ถ้าหากได้ 5 แต้มจะสามารถเลือกที่จะ',
          textSubcolor1: 'อยู่',
          textSub2: 'หรือ',
          textSubcolor2: 'จั่ว',
          textSub3: 'ก็ได้',
        },
        {
          type: 'textSubcolor',
          textSubcolor: '** ถ้าหากได้แต้มน้อยกว่า 4 เด้ง จะทำการจั่วไพ่ให้โดยอัตโนมัติ **',
          class1: 'ml-3',
        },
      ],
      ruleScore: [
        {
          type: 'text',
          text: '1. ไพ่ธรรมดา',
          class: 'ml-3',
        },
        {
          type: 'imageText',
          image: Pd1,
          class: 'w-50',
          text: 'ไพ่ 3 ใบ ไม่ว่าเจ้ามือหรือผู้เล่นมีไพ่ในมือ 2 ใบ บวกกันแต้มเป็นผลแพ้ชนะ เท่ากันถือว่าเสมอ',
        },
        {
          type: 'text',
          text: '2. ป๊อก 8 - ป๊อก 9',
          class: 'ml-3',
        },
        {
          type: 'imageText',
          image: Pd2,
          class: 'w-50',
          text: 'ไพ่ 2 ใบ บวกกันได้ 8 แต้มหรือ 9 แต้ม',
        },
        {
          type: 'text',
          text: '3. 1คู่',
          class: 'ml-3',
        },
        {
          type: 'imageText',
          image: Pd3,
          class: 'w-50',
          text: 'ไพ่ 2 ใบ แต้มเหมือนกัน',
        },
        {
          type: 'text',
          text: '4. ป๊อก 8 2เด้ง , ป๊อก 9 2เด้ง',
          class: 'ml-3',
        },
        {
          type: 'imageText',
          image: Pd4,
          class: 'w-50',
          text: 'ไพ่ 2 ใบ ดอกเดียวกัน หรือ แต้มเหมือนกัน',
        },
        {
          type: 'text',
          text: '5. ดอกเดียวกัน 2 เด้ง',
          class: 'ml-3',
        },
        {
          type: 'imageText',
          image: Pd5,
          class: 'w-50',
          text: 'ไพ่ 2 ใบ ดอกเดียวกัน หรือ แต้มเหมือนกัน',
        },
        {
          type: 'text',
          text: '6. ดอกเดียวกัน 3 เด้ง',
          class: 'ml-3',
        },
        {
          type: 'imageText',
          image: Pd6,
          class: 'w-50',
          text: 'ไพ่ 3 ใบ ดอกเดียวกันแต่ไม่เรียง',
        },
        {
          type: 'text',
          text: '7. เซียน',
          class: 'ml-3',
        },
        {
          type: 'imageText',
          image: Pd9,
          class: 'w-50',
          text: 'เป็นไพ่ในกลุ่ม J Q K ทั้ง 3 ใบ',
        },
        {
          type: 'text',
          text: '8. เรียง',
          class: 'ml-3',
        },
        {
          type: 'imageText',
          image: Pd7,
          class: 'w-50',
          text: 'ไพ่ 3 ใบ แต้มเรียงกัน',
        },
        {
          type: 'text',
          text: '9. เรียงฟลัช',
          class: 'ml-3',
        },
        {
          type: 'imageText',
          image: Pd8,
          class: 'w-50',
          text: 'ไพ่ 3 ใบเรียงกันและดอกเดียวกัน',
        },
        {
          type: 'text',
          text: '10. ตอง',
          class: 'ml-3',
        },
        {
          type: 'imageText',
          image: Pd10,
          class: 'w-50',
          text: 'ไพ่ 3 ใบเหมือนกัน',
        },
      ],
    };
  },
};
</script>

<style scoped>
.tonhg{
   /* font-size: 3vw !important;
    padding: 0 2rem !important; */
    font-size: 1.1vw;
    padding: 0 4rem;
    color: green;
}
</style>
